var map = {
	"./background.webp": 3302,
	"./clock-big.webp": 74920,
	"./clock-small.webp": 19766,
	"./clouds.webp": 58930,
	"./community-created-content.webp": 70315,
	"./dawn.webp": 29467,
	"./death.webp": 99785,
	"./demon-head.webp": 65423,
	"./demon-head2.webp": 82726,
	"./demoninfo.webp": 55735,
	"./dusk.webp": 91089,
	"./editions/bmr.webp": 41975,
	"./editions/custom.webp": 7101,
	"./editions/snv.webp": 73860,
	"./editions/tb.webp": 76280,
	"./gstone.webp": 91031,
	"./icons/Alternate/acrobat.webp": 17810,
	"./icons/Alternate/alchemist.webp": 66105,
	"./icons/Alternate/alhadikhia.webp": 51014,
	"./icons/Alternate/alsaahir.webp": 38215,
	"./icons/Alternate/amnesiac.webp": 57835,
	"./icons/Alternate/apprentice_e.webp": 51283,
	"./icons/Alternate/apprentice_g.webp": 13287,
	"./icons/Alternate/artist.webp": 3864,
	"./icons/Alternate/assassin.webp": 55196,
	"./icons/Alternate/atheist.webp": 27934,
	"./icons/Alternate/balloonist.webp": 66953,
	"./icons/Alternate/banshee.webp": 77451,
	"./icons/Alternate/barber.webp": 71483,
	"./icons/Alternate/barista_e.webp": 6101,
	"./icons/Alternate/barista_g.webp": 14776,
	"./icons/Alternate/baron.webp": 19464,
	"./icons/Alternate/beggar_e.webp": 27592,
	"./icons/Alternate/beggar_g.webp": 13819,
	"./icons/Alternate/bishop_e.webp": 7595,
	"./icons/Alternate/bishop_g.webp": 88819,
	"./icons/Alternate/boffin.webp": 18813,
	"./icons/Alternate/bonecollector_e.webp": 96642,
	"./icons/Alternate/bonecollector_g.webp": 36375,
	"./icons/Alternate/boomdandy.webp": 32355,
	"./icons/Alternate/bountyhunter.webp": 30328,
	"./icons/Alternate/bureaucrat_e.webp": 60920,
	"./icons/Alternate/bureaucrat_g.webp": 43660,
	"./icons/Alternate/butcher_e.webp": 62293,
	"./icons/Alternate/butcher_g.webp": 44952,
	"./icons/Alternate/butler.webp": 28362,
	"./icons/Alternate/cacklejack_e.webp": 25771,
	"./icons/Alternate/cacklejack_g.webp": 96243,
	"./icons/Alternate/cannibal.webp": 74892,
	"./icons/Alternate/cerenovus.webp": 78417,
	"./icons/Alternate/chambermaid.webp": 45849,
	"./icons/Alternate/chef.webp": 15858,
	"./icons/Alternate/choirboy.webp": 94152,
	"./icons/Alternate/clockmaker.webp": 75926,
	"./icons/Alternate/courtier.webp": 42219,
	"./icons/Alternate/cultleader.webp": 41509,
	"./icons/Alternate/damsel.webp": 15530,
	"./icons/Alternate/demon.webp": 61134,
	"./icons/Alternate/deviant_e.webp": 42266,
	"./icons/Alternate/deviant_g.webp": 30880,
	"./icons/Alternate/devilsadvocate.webp": 28022,
	"./icons/Alternate/dreamer.webp": 97216,
	"./icons/Alternate/drunk.webp": 88141,
	"./icons/Alternate/empath.webp": 84972,
	"./icons/Alternate/engineer.webp": 44951,
	"./icons/Alternate/eviltwin.webp": 67299,
	"./icons/Alternate/exorcist.webp": 59794,
	"./icons/Alternate/fanggu.webp": 84598,
	"./icons/Alternate/farmer.webp": 43211,
	"./icons/Alternate/fearmonger.webp": 84473,
	"./icons/Alternate/fisherman.webp": 70413,
	"./icons/Alternate/flowergirl.webp": 7415,
	"./icons/Alternate/fool.webp": 55573,
	"./icons/Alternate/fortuneteller.webp": 85604,
	"./icons/Alternate/gambler.webp": 34043,
	"./icons/Alternate/gangster_e.webp": 99627,
	"./icons/Alternate/gangster_g.webp": 32962,
	"./icons/Alternate/general.webp": 46325,
	"./icons/Alternate/gnome_e.webp": 82716,
	"./icons/Alternate/gnome_g.webp": 91679,
	"./icons/Alternate/goblin.webp": 45444,
	"./icons/Alternate/godfather.webp": 46555,
	"./icons/Alternate/golem.webp": 4789,
	"./icons/Alternate/goon.webp": 35939,
	"./icons/Alternate/gossip.webp": 1983,
	"./icons/Alternate/grandmother.webp": 35012,
	"./icons/Alternate/gunslinger_e.webp": 64285,
	"./icons/Alternate/gunslinger_g.webp": 92945,
	"./icons/Alternate/harlot_e.webp": 41204,
	"./icons/Alternate/harlot_g.webp": 9488,
	"./icons/Alternate/harpy.webp": 58579,
	"./icons/Alternate/hatter.webp": 80352,
	"./icons/Alternate/heretic.webp": 84976,
	"./icons/Alternate/hermit.webp": 39696,
	"./icons/Alternate/highpriestess.webp": 83543,
	"./icons/Alternate/huntsman.webp": 5996,
	"./icons/Alternate/imp.webp": 69922,
	"./icons/Alternate/innkeeper.webp": 8415,
	"./icons/Alternate/investigator.webp": 6368,
	"./icons/Alternate/judge_e.webp": 82809,
	"./icons/Alternate/judge_g.webp": 62255,
	"./icons/Alternate/juggler.webp": 71921,
	"./icons/Alternate/kazali.webp": 80993,
	"./icons/Alternate/king.webp": 89265,
	"./icons/Alternate/klutz.webp": 97338,
	"./icons/Alternate/knight.webp": 80915,
	"./icons/Alternate/legion.webp": 8906,
	"./icons/Alternate/leviathan.webp": 14877,
	"./icons/Alternate/librarian.webp": 66411,
	"./icons/Alternate/lilmonsta.webp": 18215,
	"./icons/Alternate/lleech.webp": 60977,
	"./icons/Alternate/lordoftyphon.webp": 42302,
	"./icons/Alternate/lunatic.webp": 43481,
	"./icons/Alternate/lycanthrope.webp": 10890,
	"./icons/Alternate/magician.webp": 5274,
	"./icons/Alternate/marionette.webp": 71745,
	"./icons/Alternate/mastermind.webp": 35588,
	"./icons/Alternate/mathematician.webp": 95732,
	"./icons/Alternate/matron_e.webp": 61165,
	"./icons/Alternate/matron_g.webp": 94112,
	"./icons/Alternate/mayor.webp": 62133,
	"./icons/Alternate/mezepheles.webp": 25106,
	"./icons/Alternate/minion.webp": 84318,
	"./icons/Alternate/minstrel.webp": 16649,
	"./icons/Alternate/monk.webp": 19936,
	"./icons/Alternate/moonchild.webp": 50680,
	"./icons/Alternate/mutant.webp": 44122,
	"./icons/Alternate/nightwatchman.webp": 20326,
	"./icons/Alternate/noble.webp": 7454,
	"./icons/Alternate/nodashii.webp": 39644,
	"./icons/Alternate/ogre.webp": 27987,
	"./icons/Alternate/ojo.webp": 92687,
	"./icons/Alternate/oracle.webp": 71710,
	"./icons/Alternate/organgrinder.webp": 61068,
	"./icons/Alternate/outsider.webp": 23399,
	"./icons/Alternate/pacifist.webp": 31199,
	"./icons/Alternate/philosopher.webp": 13276,
	"./icons/Alternate/pithag.webp": 79844,
	"./icons/Alternate/pixie.webp": 79447,
	"./icons/Alternate/plaguedoctor.webp": 84185,
	"./icons/Alternate/po.webp": 63598,
	"./icons/Alternate/poisoner.webp": 94087,
	"./icons/Alternate/politician.webp": 33033,
	"./icons/Alternate/poppygrower.webp": 31248,
	"./icons/Alternate/preacher.webp": 28170,
	"./icons/Alternate/princess.webp": 40185,
	"./icons/Alternate/professor.webp": 53176,
	"./icons/Alternate/psychopath.webp": 51017,
	"./icons/Alternate/pukka.webp": 80629,
	"./icons/Alternate/puzzlemaster.webp": 22270,
	"./icons/Alternate/ravenkeeper.webp": 42536,
	"./icons/Alternate/recluse.webp": 46320,
	"./icons/Alternate/riot.webp": 86739,
	"./icons/Alternate/sage.webp": 38201,
	"./icons/Alternate/sailor.webp": 13620,
	"./icons/Alternate/saint.webp": 54073,
	"./icons/Alternate/savant.webp": 27122,
	"./icons/Alternate/scapegoat_e.webp": 2615,
	"./icons/Alternate/scapegoat_g.webp": 57398,
	"./icons/Alternate/scarletwoman.webp": 73644,
	"./icons/Alternate/seamstress.webp": 99931,
	"./icons/Alternate/shabaloth.webp": 25273,
	"./icons/Alternate/shugenja.webp": 48542,
	"./icons/Alternate/slayer.webp": 48103,
	"./icons/Alternate/snakecharmer.webp": 37876,
	"./icons/Alternate/snitch.webp": 6398,
	"./icons/Alternate/soldier.webp": 70529,
	"./icons/Alternate/spy.webp": 24611,
	"./icons/Alternate/steward.webp": 76096,
	"./icons/Alternate/summoner.webp": 56022,
	"./icons/Alternate/sweetheart.webp": 89058,
	"./icons/Alternate/tealady.webp": 23157,
	"./icons/Alternate/thief_e.webp": 64908,
	"./icons/Alternate/thief_g.webp": 96868,
	"./icons/Alternate/tinker.webp": 78876,
	"./icons/Alternate/towncrier.webp": 86204,
	"./icons/Alternate/townsfolk.webp": 36089,
	"./icons/Alternate/traveller_e.webp": 7300,
	"./icons/Alternate/traveller_g.webp": 49954,
	"./icons/Alternate/undertaker.webp": 50124,
	"./icons/Alternate/vigormortis.webp": 12800,
	"./icons/Alternate/villageidiot.webp": 39104,
	"./icons/Alternate/virgin.webp": 81880,
	"./icons/Alternate/vizier.webp": 58882,
	"./icons/Alternate/vortox.webp": 62630,
	"./icons/Alternate/voudon_e.webp": 70804,
	"./icons/Alternate/voudon_g.webp": 82208,
	"./icons/Alternate/washerwoman.webp": 21658,
	"./icons/Alternate/widow.webp": 72006,
	"./icons/Alternate/witch.webp": 36181,
	"./icons/Alternate/wizard.webp": 54858,
	"./icons/Alternate/wraith.webp": 16472,
	"./icons/Alternate/xaan.webp": 83969,
	"./icons/Alternate/yaggababble.webp": 10650,
	"./icons/Alternate/zealot.webp": 50452,
	"./icons/Alternate/zombuul.webp": 45633,
	"./icons/acrobat.webp": 9563,
	"./icons/alchemist.webp": 26438,
	"./icons/alhadikhia.webp": 70613,
	"./icons/alsaahir.webp": 34016,
	"./icons/amnesiac.webp": 30014,
	"./icons/angel.webp": 75357,
	"./icons/apprentice.webp": 42800,
	"./icons/artist.webp": 9539,
	"./icons/assassin.webp": 2520,
	"./icons/atheist.webp": 43030,
	"./icons/balloonist.webp": 40573,
	"./icons/banshee.webp": 25968,
	"./icons/barber.webp": 79260,
	"./icons/barista.webp": 8067,
	"./icons/baron.webp": 58978,
	"./icons/beggar.webp": 31067,
	"./icons/bigwig.webp": 24641,
	"./icons/bishop.webp": 56909,
	"./icons/boffin.webp": 282,
	"./icons/bonecollector.webp": 50141,
	"./icons/boomdandy.webp": 92566,
	"./icons/bootlegger.webp": 45716,
	"./icons/bountyhunter.webp": 95134,
	"./icons/buddhist.webp": 64392,
	"./icons/bureaucrat.webp": 21968,
	"./icons/butcher.webp": 91258,
	"./icons/butler.webp": 82189,
	"./icons/cacklejack.webp": 38717,
	"./icons/cannibal.webp": 41785,
	"./icons/cerenovus.webp": 74958,
	"./icons/chambermaid.webp": 64281,
	"./icons/chef.webp": 14706,
	"./icons/choirboy.webp": 43008,
	"./icons/clockmaker.webp": 96548,
	"./icons/courtier.webp": 91858,
	"./icons/cultleader.webp": 78962,
	"./icons/damsel.webp": 41031,
	"./icons/demon.webp": 72021,
	"./icons/deusexfiasco.webp": 81965,
	"./icons/deviant.webp": 38280,
	"./icons/devilsadvocate.webp": 31018,
	"./icons/djinn.webp": 9279,
	"./icons/doomsayer.webp": 93174,
	"./icons/dreamer.webp": 8646,
	"./icons/drunk.webp": 63440,
	"./icons/duchess.webp": 35584,
	"./icons/empath.webp": 2716,
	"./icons/engineer.webp": 85071,
	"./icons/evil.webp": 33176,
	"./icons/eviltwin.webp": 72517,
	"./icons/exorcist.webp": 85174,
	"./icons/fabled.webp": 80293,
	"./icons/fanggu.webp": 18693,
	"./icons/farmer.webp": 4708,
	"./icons/fearmonger.webp": 61334,
	"./icons/ferryman.webp": 85176,
	"./icons/fibbin.webp": 7783,
	"./icons/fiddler.webp": 30926,
	"./icons/fisherman.webp": 64893,
	"./icons/flowergirl.webp": 30481,
	"./icons/fool.webp": 54158,
	"./icons/fortuneteller.webp": 49826,
	"./icons/gambler.webp": 36955,
	"./icons/gangster.webp": 53008,
	"./icons/gardener.webp": 1109,
	"./icons/general.webp": 55779,
	"./icons/gnome.webp": 96562,
	"./icons/goblin.webp": 76246,
	"./icons/godfather.webp": 63067,
	"./icons/golem.webp": 86606,
	"./icons/good.webp": 24917,
	"./icons/goon.webp": 62723,
	"./icons/gossip.webp": 61932,
	"./icons/grandmother.webp": 29056,
	"./icons/gunslinger.webp": 57480,
	"./icons/harlot.webp": 83795,
	"./icons/harpy.webp": 11890,
	"./icons/hatter.webp": 74384,
	"./icons/hellslibrarian.webp": 40757,
	"./icons/heretic.webp": 55590,
	"./icons/hermit.webp": 26621,
	"./icons/highpriestess.webp": 89492,
	"./icons/hindu.webp": 95121,
	"./icons/huntsman.webp": 15617,
	"./icons/imp.webp": 29692,
	"./icons/innkeeper.webp": 40759,
	"./icons/investigator.webp": 99506,
	"./icons/judge.webp": 78797,
	"./icons/juggler.webp": 30958,
	"./icons/kazali.webp": 26774,
	"./icons/king.webp": 35073,
	"./icons/klutz.webp": 89559,
	"./icons/knight.webp": 36615,
	"./icons/legion.webp": 62484,
	"./icons/leviathan.webp": 79859,
	"./icons/librarian.webp": 2280,
	"./icons/lilmonsta.webp": 62776,
	"./icons/lleech.webp": 18579,
	"./icons/lordoftyphon.webp": 85987,
	"./icons/loric.webp": 43369,
	"./icons/lunatic.webp": 46974,
	"./icons/lycanthrope.webp": 30861,
	"./icons/magician.webp": 51564,
	"./icons/marionette.webp": 96230,
	"./icons/mastermind.webp": 44629,
	"./icons/mathematician.webp": 59185,
	"./icons/matron.webp": 72069,
	"./icons/mayor.webp": 67214,
	"./icons/mezepheles.webp": 93225,
	"./icons/minion.webp": 984,
	"./icons/minstrel.webp": 21642,
	"./icons/monk.webp": 43437,
	"./icons/moonchild.webp": 77140,
	"./icons/mutant.webp": 16146,
	"./icons/nightwatchman.webp": 9683,
	"./icons/noble.webp": 85920,
	"./icons/nodashii.webp": 17772,
	"./icons/official/bmr/apprentice.webp": 75658,
	"./icons/official/bmr/apprentice_e.webp": 38105,
	"./icons/official/bmr/apprentice_g.webp": 9589,
	"./icons/official/bmr/assassin_e.webp": 82060,
	"./icons/official/bmr/assassin_g.webp": 43881,
	"./icons/official/bmr/bishop.webp": 95888,
	"./icons/official/bmr/bishop_e.webp": 21946,
	"./icons/official/bmr/bishop_g.webp": 98861,
	"./icons/official/bmr/chambermaid_e.webp": 77120,
	"./icons/official/bmr/chambermaid_g.webp": 86576,
	"./icons/official/bmr/courtier_e.webp": 43134,
	"./icons/official/bmr/courtier_g.webp": 62813,
	"./icons/official/bmr/devilsadvocate_e.webp": 21939,
	"./icons/official/bmr/devilsadvocate_g.webp": 76145,
	"./icons/official/bmr/exorcist_e.webp": 55761,
	"./icons/official/bmr/exorcist_g.webp": 40734,
	"./icons/official/bmr/fool_e.webp": 98438,
	"./icons/official/bmr/fool_g.webp": 91610,
	"./icons/official/bmr/gambler_e.webp": 92731,
	"./icons/official/bmr/gambler_g.webp": 62966,
	"./icons/official/bmr/godfather_e.webp": 64885,
	"./icons/official/bmr/godfather_g.webp": 40306,
	"./icons/official/bmr/goon_e.webp": 16657,
	"./icons/official/bmr/goon_g.webp": 73695,
	"./icons/official/bmr/gossip_e.webp": 91419,
	"./icons/official/bmr/gossip_g.webp": 95389,
	"./icons/official/bmr/grandmother_e.webp": 97949,
	"./icons/official/bmr/grandmother_g.webp": 46593,
	"./icons/official/bmr/innkeeper_e.webp": 17571,
	"./icons/official/bmr/innkeeper_g.webp": 98233,
	"./icons/official/bmr/judge.webp": 10809,
	"./icons/official/bmr/judge_e.webp": 96004,
	"./icons/official/bmr/judge_g.webp": 52977,
	"./icons/official/bmr/lunatic_e.webp": 30864,
	"./icons/official/bmr/lunatic_g.webp": 20597,
	"./icons/official/bmr/mastermind_e.webp": 97665,
	"./icons/official/bmr/mastermind_g.webp": 10501,
	"./icons/official/bmr/matron.webp": 56581,
	"./icons/official/bmr/matron_e.webp": 78512,
	"./icons/official/bmr/matron_g.webp": 39452,
	"./icons/official/bmr/minstrel_e.webp": 58851,
	"./icons/official/bmr/minstrel_g.webp": 36159,
	"./icons/official/bmr/moonchild_e.webp": 72107,
	"./icons/official/bmr/moonchild_g.webp": 1045,
	"./icons/official/bmr/pacifist_e.webp": 78837,
	"./icons/official/bmr/pacifist_g.webp": 20521,
	"./icons/official/bmr/po_e.webp": 95106,
	"./icons/official/bmr/po_g.webp": 62806,
	"./icons/official/bmr/professor_e.webp": 1975,
	"./icons/official/bmr/professor_g.webp": 11962,
	"./icons/official/bmr/pukka_e.webp": 9950,
	"./icons/official/bmr/pukka_g.webp": 88665,
	"./icons/official/bmr/sailor_e.webp": 94138,
	"./icons/official/bmr/sailor_g.webp": 65352,
	"./icons/official/bmr/shabaloth_e.webp": 55212,
	"./icons/official/bmr/shabaloth_g.webp": 14155,
	"./icons/official/bmr/tealady_e.webp": 77601,
	"./icons/official/bmr/tealady_g.webp": 59326,
	"./icons/official/bmr/tinker_e.webp": 86657,
	"./icons/official/bmr/tinker_g.webp": 48118,
	"./icons/official/bmr/voudon.webp": 85405,
	"./icons/official/bmr/voudon_e.webp": 70168,
	"./icons/official/bmr/voudon_g.webp": 12454,
	"./icons/official/bmr/zombuul_e.webp": 85973,
	"./icons/official/bmr/zombuul_g.webp": 68127,
	"./icons/official/carousel/acrobat_e.webp": 48662,
	"./icons/official/carousel/acrobat_g.webp": 99335,
	"./icons/official/carousel/alchemist_e.webp": 73454,
	"./icons/official/carousel/alchemist_g.webp": 68584,
	"./icons/official/carousel/alhadikhia_e.webp": 76220,
	"./icons/official/carousel/alhadikhia_g.webp": 32704,
	"./icons/official/carousel/alsaahir_e.webp": 38378,
	"./icons/official/carousel/alsaahir_g.webp": 45103,
	"./icons/official/carousel/amnesiac_e.webp": 94828,
	"./icons/official/carousel/amnesiac_g.webp": 9700,
	"./icons/official/carousel/atheist_e.webp": 10961,
	"./icons/official/carousel/atheist_g.webp": 7570,
	"./icons/official/carousel/balloonist_e.webp": 49510,
	"./icons/official/carousel/balloonist_g.webp": 81677,
	"./icons/official/carousel/banshee_e.webp": 99497,
	"./icons/official/carousel/banshee_g.webp": 99974,
	"./icons/official/carousel/boffin_e.webp": 75394,
	"./icons/official/carousel/boffin_g.webp": 71631,
	"./icons/official/carousel/boomdandy_e.webp": 44373,
	"./icons/official/carousel/boomdandy_g.webp": 67744,
	"./icons/official/carousel/bountyhunter_e.webp": 40994,
	"./icons/official/carousel/bountyhunter_g.webp": 17400,
	"./icons/official/carousel/cacklejack.webp": 25346,
	"./icons/official/carousel/cacklejack_e.webp": 80050,
	"./icons/official/carousel/cacklejack_g.webp": 56555,
	"./icons/official/carousel/cannibal_e.webp": 95180,
	"./icons/official/carousel/cannibal_g.webp": 11931,
	"./icons/official/carousel/choirboy_e.webp": 10167,
	"./icons/official/carousel/choirboy_g.webp": 31166,
	"./icons/official/carousel/cultleader_e.webp": 21592,
	"./icons/official/carousel/cultleader_g.webp": 49850,
	"./icons/official/carousel/damsel_e.webp": 99029,
	"./icons/official/carousel/damsel_g.webp": 9541,
	"./icons/official/carousel/deusexfiasco.webp": 77410,
	"./icons/official/carousel/engineer_e.webp": 46887,
	"./icons/official/carousel/engineer_g.webp": 82625,
	"./icons/official/carousel/farmer_e.webp": 27411,
	"./icons/official/carousel/farmer_g.webp": 72141,
	"./icons/official/carousel/fearmonger_e.webp": 78824,
	"./icons/official/carousel/fearmonger_g.webp": 43145,
	"./icons/official/carousel/ferryman.webp": 35861,
	"./icons/official/carousel/fisherman_e.webp": 21331,
	"./icons/official/carousel/fisherman_g.webp": 66110,
	"./icons/official/carousel/gangster.webp": 39414,
	"./icons/official/carousel/gangster_e.webp": 38426,
	"./icons/official/carousel/gangster_g.webp": 59277,
	"./icons/official/carousel/general_e.webp": 8216,
	"./icons/official/carousel/general_g.webp": 81520,
	"./icons/official/carousel/gnome.webp": 7312,
	"./icons/official/carousel/gnome_e.webp": 16310,
	"./icons/official/carousel/gnome_g.webp": 88726,
	"./icons/official/carousel/goblin_e.webp": 41766,
	"./icons/official/carousel/goblin_g.webp": 82848,
	"./icons/official/carousel/golem_e.webp": 2074,
	"./icons/official/carousel/golem_g.webp": 33710,
	"./icons/official/carousel/harpy_e.webp": 41776,
	"./icons/official/carousel/harpy_g.webp": 95554,
	"./icons/official/carousel/hatter_e.webp": 38515,
	"./icons/official/carousel/hatter_g.webp": 99648,
	"./icons/official/carousel/heretic_e.webp": 91789,
	"./icons/official/carousel/heretic_g.webp": 44847,
	"./icons/official/carousel/hermit_e.webp": 98871,
	"./icons/official/carousel/hermit_g.webp": 63649,
	"./icons/official/carousel/highpriestess_e.webp": 26055,
	"./icons/official/carousel/highpriestess_g.webp": 52852,
	"./icons/official/carousel/huntsman_e.webp": 9765,
	"./icons/official/carousel/huntsman_g.webp": 36643,
	"./icons/official/carousel/kazali_e.webp": 68682,
	"./icons/official/carousel/kazali_g.webp": 76223,
	"./icons/official/carousel/king_e.webp": 25416,
	"./icons/official/carousel/king_g.webp": 79440,
	"./icons/official/carousel/knight_e.webp": 11111,
	"./icons/official/carousel/knight_g.webp": 49016,
	"./icons/official/carousel/legion_e.webp": 72367,
	"./icons/official/carousel/legion_g.webp": 86120,
	"./icons/official/carousel/leviathan_e.webp": 31754,
	"./icons/official/carousel/leviathan_g.webp": 12140,
	"./icons/official/carousel/lilmonsta_e.webp": 89115,
	"./icons/official/carousel/lilmonsta_g.webp": 86219,
	"./icons/official/carousel/lleech_e.webp": 82541,
	"./icons/official/carousel/lleech_g.webp": 13661,
	"./icons/official/carousel/lordoftyphon_e.webp": 37426,
	"./icons/official/carousel/lordoftyphon_g.webp": 23430,
	"./icons/official/carousel/lycanthrope_e.webp": 24151,
	"./icons/official/carousel/lycanthrope_g.webp": 14195,
	"./icons/official/carousel/magician_e.webp": 3007,
	"./icons/official/carousel/magician_g.webp": 38352,
	"./icons/official/carousel/marionette_e.webp": 84289,
	"./icons/official/carousel/marionette_g.webp": 52634,
	"./icons/official/carousel/mezepheles_e.webp": 39459,
	"./icons/official/carousel/mezepheles_g.webp": 94326,
	"./icons/official/carousel/nightwatchman_e.webp": 74439,
	"./icons/official/carousel/nightwatchman_g.webp": 9310,
	"./icons/official/carousel/noble_e.webp": 95867,
	"./icons/official/carousel/noble_g.webp": 6895,
	"./icons/official/carousel/ogre_e.webp": 10800,
	"./icons/official/carousel/ogre_g.webp": 28150,
	"./icons/official/carousel/ojo_e.webp": 25258,
	"./icons/official/carousel/ojo_g.webp": 45578,
	"./icons/official/carousel/organgrinder_e.webp": 32745,
	"./icons/official/carousel/organgrinder_g.webp": 41108,
	"./icons/official/carousel/pixie_e.webp": 93160,
	"./icons/official/carousel/pixie_g.webp": 98277,
	"./icons/official/carousel/plaguedoctor_e.webp": 92636,
	"./icons/official/carousel/plaguedoctor_g.webp": 11348,
	"./icons/official/carousel/politician_e.webp": 66835,
	"./icons/official/carousel/politician_g.webp": 68803,
	"./icons/official/carousel/poppygrower_e.webp": 34062,
	"./icons/official/carousel/poppygrower_g.webp": 14193,
	"./icons/official/carousel/preacher_e.webp": 94655,
	"./icons/official/carousel/preacher_g.webp": 88218,
	"./icons/official/carousel/princess_e.webp": 7644,
	"./icons/official/carousel/princess_g.webp": 18104,
	"./icons/official/carousel/psychopath_e.webp": 34456,
	"./icons/official/carousel/psychopath_g.webp": 68297,
	"./icons/official/carousel/puzzlemaster_e.webp": 90038,
	"./icons/official/carousel/puzzlemaster_g.webp": 65439,
	"./icons/official/carousel/riot_e.webp": 52735,
	"./icons/official/carousel/riot_g.webp": 97492,
	"./icons/official/carousel/shugenja_e.webp": 96482,
	"./icons/official/carousel/shugenja_g.webp": 69778,
	"./icons/official/carousel/snitch_e.webp": 76561,
	"./icons/official/carousel/snitch_g.webp": 28298,
	"./icons/official/carousel/steward_e.webp": 59482,
	"./icons/official/carousel/steward_g.webp": 65314,
	"./icons/official/carousel/summoner_e.webp": 31418,
	"./icons/official/carousel/summoner_g.webp": 81375,
	"./icons/official/carousel/villageidiot_e.webp": 65119,
	"./icons/official/carousel/villageidiot_g.webp": 77391,
	"./icons/official/carousel/vizier_e.webp": 89211,
	"./icons/official/carousel/vizier_g.webp": 80726,
	"./icons/official/carousel/widow_e.webp": 50392,
	"./icons/official/carousel/widow_g.webp": 32375,
	"./icons/official/carousel/wizard_e.webp": 66160,
	"./icons/official/carousel/wizard_g.webp": 90171,
	"./icons/official/carousel/wraith_e.webp": 50768,
	"./icons/official/carousel/wraith_g.webp": 80995,
	"./icons/official/carousel/xaan_e.webp": 81268,
	"./icons/official/carousel/xaan_g.webp": 9108,
	"./icons/official/carousel/yaggababble_e.webp": 95053,
	"./icons/official/carousel/yaggababble_g.webp": 43580,
	"./icons/official/carousel/zealot_e.webp": 71915,
	"./icons/official/carousel/zealot_g.webp": 62436,
	"./icons/official/fabled/angel.webp": 20793,
	"./icons/official/fabled/buddhist.webp": 17852,
	"./icons/official/fabled/djinn.webp": 21044,
	"./icons/official/fabled/doomsayer.webp": 81334,
	"./icons/official/fabled/duchess.webp": 25268,
	"./icons/official/fabled/fibbin.webp": 6713,
	"./icons/official/fabled/fiddler.webp": 19946,
	"./icons/official/fabled/hellslibrarian.webp": 7707,
	"./icons/official/fabled/revolutionary.webp": 51570,
	"./icons/official/fabled/sentinel.webp": 95892,
	"./icons/official/fabled/spiritofivory.webp": 40996,
	"./icons/official/fabled/toymaker.webp": 44380,
	"./icons/official/generic/custom.webp": 96148,
	"./icons/official/generic/custom_e.webp": 50359,
	"./icons/official/generic/custom_g.webp": 74938,
	"./icons/official/generic/demon.webp": 87357,
	"./icons/official/generic/demon_e.webp": 16799,
	"./icons/official/generic/demon_g.webp": 63442,
	"./icons/official/generic/evil.webp": 71535,
	"./icons/official/generic/fabled.webp": 91243,
	"./icons/official/generic/good.webp": 50838,
	"./icons/official/generic/loric.webp": 38323,
	"./icons/official/generic/minion.webp": 33321,
	"./icons/official/generic/minion_e.webp": 37693,
	"./icons/official/generic/minion_g.webp": 89999,
	"./icons/official/generic/outsider.webp": 6523,
	"./icons/official/generic/outsider_e.webp": 87623,
	"./icons/official/generic/outsider_g.webp": 11901,
	"./icons/official/generic/townsfolk.webp": 28116,
	"./icons/official/generic/townsfolk_e.webp": 73315,
	"./icons/official/generic/townsfolk_g.webp": 27198,
	"./icons/official/generic/traveller.webp": 98993,
	"./icons/official/generic/traveller_e.webp": 30665,
	"./icons/official/generic/traveller_g.webp": 70095,
	"./icons/official/loric/bigwig.webp": 17327,
	"./icons/official/loric/bootlegger.webp": 33436,
	"./icons/official/loric/gardener.webp": 27643,
	"./icons/official/loric/godofug.webp": 92245,
	"./icons/official/loric/hindu.webp": 96794,
	"./icons/official/loric/knaves.webp": 94732,
	"./icons/official/loric/pope.webp": 62905,
	"./icons/official/loric/stormcatcher.webp": 38665,
	"./icons/official/loric/tor.webp": 58404,
	"./icons/official/loric/ventriloquist.webp": 15435,
	"./icons/official/loric/zenomancer.webp": 7168,
	"./icons/official/snv/artist_e.webp": 40261,
	"./icons/official/snv/artist_g.webp": 98090,
	"./icons/official/snv/barber_e.webp": 68855,
	"./icons/official/snv/barber_g.webp": 34245,
	"./icons/official/snv/barista.webp": 99705,
	"./icons/official/snv/barista_e.webp": 84056,
	"./icons/official/snv/barista_g.webp": 92750,
	"./icons/official/snv/bonecollector.webp": 26123,
	"./icons/official/snv/bonecollector_e.webp": 94803,
	"./icons/official/snv/bonecollector_g.webp": 86476,
	"./icons/official/snv/butcher.webp": 45053,
	"./icons/official/snv/butcher_e.webp": 43797,
	"./icons/official/snv/butcher_g.webp": 85313,
	"./icons/official/snv/cerenovus_e.webp": 40855,
	"./icons/official/snv/cerenovus_g.webp": 75718,
	"./icons/official/snv/clockmaker_e.webp": 96435,
	"./icons/official/snv/clockmaker_g.webp": 53512,
	"./icons/official/snv/deviant.webp": 59164,
	"./icons/official/snv/deviant_e.webp": 60849,
	"./icons/official/snv/deviant_g.webp": 68451,
	"./icons/official/snv/dreamer_e.webp": 20309,
	"./icons/official/snv/dreamer_g.webp": 43791,
	"./icons/official/snv/eviltwin_e.webp": 53380,
	"./icons/official/snv/eviltwin_g.webp": 4341,
	"./icons/official/snv/fanggu_e.webp": 15149,
	"./icons/official/snv/fanggu_g.webp": 79635,
	"./icons/official/snv/flowergirl_e.webp": 74084,
	"./icons/official/snv/flowergirl_g.webp": 62506,
	"./icons/official/snv/harlot.webp": 56544,
	"./icons/official/snv/harlot_e.webp": 91673,
	"./icons/official/snv/harlot_g.webp": 49366,
	"./icons/official/snv/juggler_e.webp": 67351,
	"./icons/official/snv/juggler_g.webp": 97506,
	"./icons/official/snv/klutz_e.webp": 83010,
	"./icons/official/snv/klutz_g.webp": 98487,
	"./icons/official/snv/mathematician_e.webp": 67654,
	"./icons/official/snv/mathematician_g.webp": 40978,
	"./icons/official/snv/mutant_e.webp": 59543,
	"./icons/official/snv/mutant_g.webp": 39305,
	"./icons/official/snv/nodashii_e.webp": 78815,
	"./icons/official/snv/nodashii_g.webp": 37123,
	"./icons/official/snv/oracle_e.webp": 54419,
	"./icons/official/snv/oracle_g.webp": 4632,
	"./icons/official/snv/philosopher_e.webp": 3039,
	"./icons/official/snv/philosopher_g.webp": 7307,
	"./icons/official/snv/pithag_e.webp": 78259,
	"./icons/official/snv/pithag_g.webp": 98050,
	"./icons/official/snv/sage_e.webp": 78338,
	"./icons/official/snv/sage_g.webp": 90193,
	"./icons/official/snv/savant_e.webp": 40949,
	"./icons/official/snv/savant_g.webp": 23941,
	"./icons/official/snv/seamstress_e.webp": 23292,
	"./icons/official/snv/seamstress_g.webp": 89638,
	"./icons/official/snv/snakecharmer_e.webp": 39400,
	"./icons/official/snv/snakecharmer_g.webp": 26217,
	"./icons/official/snv/sweetheart_e.webp": 2731,
	"./icons/official/snv/sweetheart_g.webp": 13498,
	"./icons/official/snv/towncrier_e.webp": 85840,
	"./icons/official/snv/towncrier_g.webp": 19090,
	"./icons/official/snv/vigormortis_e.webp": 26830,
	"./icons/official/snv/vigormortis_g.webp": 26685,
	"./icons/official/snv/vortox_e.webp": 34524,
	"./icons/official/snv/vortox_g.webp": 43192,
	"./icons/official/snv/witch_e.webp": 50611,
	"./icons/official/snv/witch_g.webp": 79942,
	"./icons/official/tb/baron_e.webp": 88005,
	"./icons/official/tb/baron_g.webp": 51488,
	"./icons/official/tb/beggar.webp": 94449,
	"./icons/official/tb/beggar_e.webp": 76595,
	"./icons/official/tb/beggar_g.webp": 65449,
	"./icons/official/tb/bureaucrat.webp": 90835,
	"./icons/official/tb/bureaucrat_e.webp": 47139,
	"./icons/official/tb/bureaucrat_g.webp": 1340,
	"./icons/official/tb/butler_e.webp": 36509,
	"./icons/official/tb/butler_g.webp": 90089,
	"./icons/official/tb/chef_e.webp": 97837,
	"./icons/official/tb/chef_g.webp": 17013,
	"./icons/official/tb/drunk_e.webp": 71540,
	"./icons/official/tb/drunk_g.webp": 70495,
	"./icons/official/tb/empath_e.webp": 26966,
	"./icons/official/tb/empath_g.webp": 92378,
	"./icons/official/tb/fortuneteller_e.webp": 26015,
	"./icons/official/tb/fortuneteller_g.webp": 14226,
	"./icons/official/tb/gunslinger.webp": 64621,
	"./icons/official/tb/gunslinger_e.webp": 64795,
	"./icons/official/tb/gunslinger_g.webp": 15687,
	"./icons/official/tb/imp_e.webp": 73546,
	"./icons/official/tb/imp_g.webp": 28979,
	"./icons/official/tb/investigator_e.webp": 58378,
	"./icons/official/tb/investigator_g.webp": 17660,
	"./icons/official/tb/librarian_e.webp": 70850,
	"./icons/official/tb/librarian_g.webp": 31007,
	"./icons/official/tb/mayor_e.webp": 71486,
	"./icons/official/tb/mayor_g.webp": 35770,
	"./icons/official/tb/monk_e.webp": 46217,
	"./icons/official/tb/monk_g.webp": 65987,
	"./icons/official/tb/poisoner_e.webp": 96094,
	"./icons/official/tb/poisoner_g.webp": 11447,
	"./icons/official/tb/ravenkeeper_e.webp": 232,
	"./icons/official/tb/ravenkeeper_g.webp": 5014,
	"./icons/official/tb/recluse_e.webp": 31131,
	"./icons/official/tb/recluse_g.webp": 13553,
	"./icons/official/tb/saint_e.webp": 30380,
	"./icons/official/tb/saint_g.webp": 51431,
	"./icons/official/tb/scapegoat.webp": 40619,
	"./icons/official/tb/scapegoat_e.webp": 51707,
	"./icons/official/tb/scapegoat_g.webp": 98041,
	"./icons/official/tb/scarletwoman_e.webp": 47939,
	"./icons/official/tb/scarletwoman_g.webp": 76637,
	"./icons/official/tb/slayer_e.webp": 71519,
	"./icons/official/tb/slayer_g.webp": 25873,
	"./icons/official/tb/soldier_e.webp": 68322,
	"./icons/official/tb/soldier_g.webp": 18189,
	"./icons/official/tb/spy_e.webp": 49085,
	"./icons/official/tb/spy_g.webp": 72200,
	"./icons/official/tb/thief.webp": 6293,
	"./icons/official/tb/thief_e.webp": 76358,
	"./icons/official/tb/thief_g.webp": 17944,
	"./icons/official/tb/undertaker_e.webp": 76045,
	"./icons/official/tb/undertaker_g.webp": 80130,
	"./icons/official/tb/virgin_e.webp": 1402,
	"./icons/official/tb/virgin_g.webp": 85272,
	"./icons/official/tb/washerwoman_e.webp": 88426,
	"./icons/official/tb/washerwoman_g.webp": 40801,
	"./icons/ogre.webp": 30704,
	"./icons/ojo.webp": 20446,
	"./icons/oracle.webp": 97905,
	"./icons/organgrinder.webp": 32479,
	"./icons/outsider.webp": 31936,
	"./icons/pacifist.webp": 6715,
	"./icons/philosopher.webp": 34349,
	"./icons/pithag.webp": 66012,
	"./icons/pixie.webp": 32120,
	"./icons/plaguedoctor.webp": 32746,
	"./icons/po.webp": 57441,
	"./icons/poisoner.webp": 73009,
	"./icons/politician.webp": 65558,
	"./icons/pope.webp": 11937,
	"./icons/poppygrower.webp": 53058,
	"./icons/preacher.webp": 38497,
	"./icons/princess.webp": 40710,
	"./icons/professor.webp": 7249,
	"./icons/psychopath.webp": 11132,
	"./icons/pukka.webp": 2950,
	"./icons/puzzlemaster.webp": 51913,
	"./icons/ravenkeeper.webp": 68486,
	"./icons/recluse.webp": 69192,
	"./icons/revolutionary.webp": 96069,
	"./icons/riot.webp": 50160,
	"./icons/sage.webp": 52979,
	"./icons/sailor.webp": 62762,
	"./icons/saint.webp": 65417,
	"./icons/savant.webp": 78931,
	"./icons/scapegoat.webp": 68641,
	"./icons/scarletwoman.webp": 94764,
	"./icons/seamstress.webp": 55778,
	"./icons/sentinel.webp": 99480,
	"./icons/shabaloth.webp": 83893,
	"./icons/shugenja.webp": 34360,
	"./icons/slayer.webp": 28405,
	"./icons/snakecharmer.webp": 57903,
	"./icons/snitch.webp": 68139,
	"./icons/soldier.webp": 379,
	"./icons/spiritofivory.webp": 57579,
	"./icons/spy.webp": 60767,
	"./icons/steward.webp": 97958,
	"./icons/stormcatcher.webp": 73215,
	"./icons/summoner.webp": 85596,
	"./icons/sweetheart.webp": 74301,
	"./icons/tealady.webp": 91382,
	"./icons/thief.webp": 77938,
	"./icons/tinker.webp": 24980,
	"./icons/tor.webp": 69685,
	"./icons/towncrier.webp": 4622,
	"./icons/townsfolk.webp": 6712,
	"./icons/toymaker.webp": 22287,
	"./icons/traveller.webp": 43411,
	"./icons/undertaker.webp": 8222,
	"./icons/unofficial/Alternate/acrobat.webp": 82177,
	"./icons/unofficial/Alternate/alchemist.webp": 25081,
	"./icons/unofficial/Alternate/alhadikhia.webp": 4951,
	"./icons/unofficial/Alternate/alsaahir.webp": 46874,
	"./icons/unofficial/Alternate/amnesiac.webp": 87583,
	"./icons/unofficial/Alternate/apprentice_e.webp": 29037,
	"./icons/unofficial/Alternate/apprentice_g.webp": 16385,
	"./icons/unofficial/Alternate/artist.webp": 11724,
	"./icons/unofficial/Alternate/assassin.webp": 49407,
	"./icons/unofficial/Alternate/atheist.webp": 85877,
	"./icons/unofficial/Alternate/balloonist.webp": 4058,
	"./icons/unofficial/Alternate/banshee.webp": 45257,
	"./icons/unofficial/Alternate/barber.webp": 92531,
	"./icons/unofficial/Alternate/barista_e.webp": 75211,
	"./icons/unofficial/Alternate/barista_g.webp": 53274,
	"./icons/unofficial/Alternate/baron.webp": 78335,
	"./icons/unofficial/Alternate/beggar_e.webp": 94113,
	"./icons/unofficial/Alternate/beggar_g.webp": 84441,
	"./icons/unofficial/Alternate/bishop_e.webp": 74734,
	"./icons/unofficial/Alternate/bishop_g.webp": 45060,
	"./icons/unofficial/Alternate/boffin.webp": 82186,
	"./icons/unofficial/Alternate/bonecollector_e.webp": 72182,
	"./icons/unofficial/Alternate/bonecollector_g.webp": 79438,
	"./icons/unofficial/Alternate/boomdandy.webp": 62065,
	"./icons/unofficial/Alternate/bountyhunter.webp": 83299,
	"./icons/unofficial/Alternate/bureaucrat_e.webp": 87526,
	"./icons/unofficial/Alternate/bureaucrat_g.webp": 40016,
	"./icons/unofficial/Alternate/butcher_e.webp": 50105,
	"./icons/unofficial/Alternate/butcher_g.webp": 35258,
	"./icons/unofficial/Alternate/butler.webp": 16482,
	"./icons/unofficial/Alternate/cacklejack_e.webp": 36647,
	"./icons/unofficial/Alternate/cacklejack_g.webp": 17838,
	"./icons/unofficial/Alternate/cannibal.webp": 46621,
	"./icons/unofficial/Alternate/cerenovus.webp": 92587,
	"./icons/unofficial/Alternate/chambermaid.webp": 50146,
	"./icons/unofficial/Alternate/chef.webp": 97830,
	"./icons/unofficial/Alternate/choirboy.webp": 36281,
	"./icons/unofficial/Alternate/clockmaker.webp": 3472,
	"./icons/unofficial/Alternate/courtier.webp": 81221,
	"./icons/unofficial/Alternate/cultleader.webp": 60274,
	"./icons/unofficial/Alternate/damsel.webp": 63945,
	"./icons/unofficial/Alternate/demon.webp": 97009,
	"./icons/unofficial/Alternate/deviant_e.webp": 37859,
	"./icons/unofficial/Alternate/deviant_g.webp": 8461,
	"./icons/unofficial/Alternate/devilsadvocate.webp": 23675,
	"./icons/unofficial/Alternate/dreamer.webp": 6277,
	"./icons/unofficial/Alternate/drunk.webp": 94118,
	"./icons/unofficial/Alternate/empath.webp": 60620,
	"./icons/unofficial/Alternate/engineer.webp": 29717,
	"./icons/unofficial/Alternate/eviltwin.webp": 37151,
	"./icons/unofficial/Alternate/exorcist.webp": 81827,
	"./icons/unofficial/Alternate/fanggu.webp": 32714,
	"./icons/unofficial/Alternate/farmer.webp": 41441,
	"./icons/unofficial/Alternate/fearmonger.webp": 90946,
	"./icons/unofficial/Alternate/fisherman.webp": 68125,
	"./icons/unofficial/Alternate/flowergirl.webp": 2198,
	"./icons/unofficial/Alternate/fool.webp": 61835,
	"./icons/unofficial/Alternate/fortuneteller.webp": 51876,
	"./icons/unofficial/Alternate/gambler.webp": 60563,
	"./icons/unofficial/Alternate/gangster_e.webp": 15799,
	"./icons/unofficial/Alternate/gangster_g.webp": 70976,
	"./icons/unofficial/Alternate/general.webp": 47326,
	"./icons/unofficial/Alternate/gnome_e.webp": 3220,
	"./icons/unofficial/Alternate/gnome_g.webp": 23846,
	"./icons/unofficial/Alternate/goblin.webp": 92162,
	"./icons/unofficial/Alternate/godfather.webp": 69598,
	"./icons/unofficial/Alternate/golem.webp": 83668,
	"./icons/unofficial/Alternate/goon.webp": 18788,
	"./icons/unofficial/Alternate/gossip.webp": 57328,
	"./icons/unofficial/Alternate/grandmother.webp": 6404,
	"./icons/unofficial/Alternate/gunslinger_e.webp": 77192,
	"./icons/unofficial/Alternate/gunslinger_g.webp": 24785,
	"./icons/unofficial/Alternate/harlot_e.webp": 4889,
	"./icons/unofficial/Alternate/harlot_g.webp": 63223,
	"./icons/unofficial/Alternate/harpy.webp": 26095,
	"./icons/unofficial/Alternate/hatter.webp": 23946,
	"./icons/unofficial/Alternate/heretic.webp": 94939,
	"./icons/unofficial/Alternate/hermit.webp": 42030,
	"./icons/unofficial/Alternate/highpriestess.webp": 26606,
	"./icons/unofficial/Alternate/huntsman.webp": 47422,
	"./icons/unofficial/Alternate/imp.webp": 88803,
	"./icons/unofficial/Alternate/innkeeper.webp": 72501,
	"./icons/unofficial/Alternate/investigator.webp": 61630,
	"./icons/unofficial/Alternate/judge_e.webp": 98782,
	"./icons/unofficial/Alternate/judge_g.webp": 64922,
	"./icons/unofficial/Alternate/juggler.webp": 34284,
	"./icons/unofficial/Alternate/kazali.webp": 43127,
	"./icons/unofficial/Alternate/king.webp": 91510,
	"./icons/unofficial/Alternate/klutz.webp": 85684,
	"./icons/unofficial/Alternate/knight.webp": 14987,
	"./icons/unofficial/Alternate/legion.webp": 40018,
	"./icons/unofficial/Alternate/leviathan.webp": 5201,
	"./icons/unofficial/Alternate/librarian.webp": 56433,
	"./icons/unofficial/Alternate/lilmonsta.webp": 54351,
	"./icons/unofficial/Alternate/lleech.webp": 93260,
	"./icons/unofficial/Alternate/lordoftyphon.webp": 94531,
	"./icons/unofficial/Alternate/lunatic.webp": 84019,
	"./icons/unofficial/Alternate/lycanthrope.webp": 66291,
	"./icons/unofficial/Alternate/magician.webp": 59828,
	"./icons/unofficial/Alternate/marionette.webp": 33988,
	"./icons/unofficial/Alternate/mastermind.webp": 81725,
	"./icons/unofficial/Alternate/mathematician.webp": 49410,
	"./icons/unofficial/Alternate/matron_e.webp": 13241,
	"./icons/unofficial/Alternate/matron_g.webp": 50372,
	"./icons/unofficial/Alternate/mayor.webp": 10211,
	"./icons/unofficial/Alternate/mezepheles.webp": 74207,
	"./icons/unofficial/Alternate/minion.webp": 94222,
	"./icons/unofficial/Alternate/minstrel.webp": 82426,
	"./icons/unofficial/Alternate/monk.webp": 54067,
	"./icons/unofficial/Alternate/moonchild.webp": 23243,
	"./icons/unofficial/Alternate/mutant.webp": 73140,
	"./icons/unofficial/Alternate/nightwatchman.webp": 14914,
	"./icons/unofficial/Alternate/noble.webp": 27283,
	"./icons/unofficial/Alternate/nodashii.webp": 97244,
	"./icons/unofficial/Alternate/ogre.webp": 51492,
	"./icons/unofficial/Alternate/ojo.webp": 33696,
	"./icons/unofficial/Alternate/oracle.webp": 54388,
	"./icons/unofficial/Alternate/organgrinder.webp": 87328,
	"./icons/unofficial/Alternate/outsider.webp": 24107,
	"./icons/unofficial/Alternate/pacifist.webp": 56171,
	"./icons/unofficial/Alternate/philosopher.webp": 65672,
	"./icons/unofficial/Alternate/pithag.webp": 60055,
	"./icons/unofficial/Alternate/pixie.webp": 74690,
	"./icons/unofficial/Alternate/plaguedoctor.webp": 28710,
	"./icons/unofficial/Alternate/po.webp": 15341,
	"./icons/unofficial/Alternate/poisoner.webp": 90233,
	"./icons/unofficial/Alternate/politician.webp": 39444,
	"./icons/unofficial/Alternate/poppygrower.webp": 58148,
	"./icons/unofficial/Alternate/preacher.webp": 7966,
	"./icons/unofficial/Alternate/princess.webp": 83774,
	"./icons/unofficial/Alternate/professor.webp": 4694,
	"./icons/unofficial/Alternate/psychopath.webp": 38349,
	"./icons/unofficial/Alternate/pukka.webp": 67527,
	"./icons/unofficial/Alternate/puzzlemaster.webp": 92416,
	"./icons/unofficial/Alternate/ravenkeeper.webp": 65074,
	"./icons/unofficial/Alternate/recluse.webp": 17463,
	"./icons/unofficial/Alternate/riot.webp": 6723,
	"./icons/unofficial/Alternate/sage.webp": 15456,
	"./icons/unofficial/Alternate/sailor.webp": 11796,
	"./icons/unofficial/Alternate/saint.webp": 1090,
	"./icons/unofficial/Alternate/savant.webp": 11122,
	"./icons/unofficial/Alternate/scapegoat_e.webp": 64476,
	"./icons/unofficial/Alternate/scapegoat_g.webp": 94434,
	"./icons/unofficial/Alternate/scarletwoman.webp": 14560,
	"./icons/unofficial/Alternate/seamstress.webp": 43258,
	"./icons/unofficial/Alternate/shabaloth.webp": 91550,
	"./icons/unofficial/Alternate/shugenja.webp": 98484,
	"./icons/unofficial/Alternate/slayer.webp": 62149,
	"./icons/unofficial/Alternate/snakecharmer.webp": 2196,
	"./icons/unofficial/Alternate/snitch.webp": 65184,
	"./icons/unofficial/Alternate/soldier.webp": 20463,
	"./icons/unofficial/Alternate/spy.webp": 19918,
	"./icons/unofficial/Alternate/steward.webp": 31244,
	"./icons/unofficial/Alternate/summoner.webp": 19826,
	"./icons/unofficial/Alternate/sweetheart.webp": 64386,
	"./icons/unofficial/Alternate/tealady.webp": 60460,
	"./icons/unofficial/Alternate/thief_e.webp": 36735,
	"./icons/unofficial/Alternate/thief_g.webp": 97540,
	"./icons/unofficial/Alternate/tinker.webp": 74763,
	"./icons/unofficial/Alternate/towncrier.webp": 78615,
	"./icons/unofficial/Alternate/townsfolk.webp": 79507,
	"./icons/unofficial/Alternate/traveller_e.webp": 26361,
	"./icons/unofficial/Alternate/traveller_g.webp": 12499,
	"./icons/unofficial/Alternate/undertaker.webp": 10553,
	"./icons/unofficial/Alternate/vigormortis.webp": 97867,
	"./icons/unofficial/Alternate/villageidiot.webp": 99474,
	"./icons/unofficial/Alternate/virgin.webp": 78644,
	"./icons/unofficial/Alternate/vizier.webp": 41063,
	"./icons/unofficial/Alternate/vortox.webp": 65022,
	"./icons/unofficial/Alternate/voudon_e.webp": 69965,
	"./icons/unofficial/Alternate/voudon_g.webp": 24960,
	"./icons/unofficial/Alternate/washerwoman.webp": 74481,
	"./icons/unofficial/Alternate/widow.webp": 85287,
	"./icons/unofficial/Alternate/witch.webp": 66518,
	"./icons/unofficial/Alternate/wizard.webp": 64735,
	"./icons/unofficial/Alternate/wraith.webp": 70157,
	"./icons/unofficial/Alternate/xaan.webp": 66827,
	"./icons/unofficial/Alternate/yaggababble.webp": 85760,
	"./icons/unofficial/Alternate/zealot.webp": 13592,
	"./icons/unofficial/Alternate/zombuul.webp": 63201,
	"./icons/unofficial/acrobat.webp": 1917,
	"./icons/unofficial/alchemist.webp": 57651,
	"./icons/unofficial/alhadikhia.webp": 68362,
	"./icons/unofficial/alsaahir.webp": 49678,
	"./icons/unofficial/amnesiac.webp": 18751,
	"./icons/unofficial/angel.webp": 2390,
	"./icons/unofficial/apprentice.webp": 82686,
	"./icons/unofficial/artist.webp": 42277,
	"./icons/unofficial/assassin.webp": 79606,
	"./icons/unofficial/atheist.webp": 52445,
	"./icons/unofficial/balloonist.webp": 49857,
	"./icons/unofficial/banshee.webp": 69176,
	"./icons/unofficial/barber.webp": 31313,
	"./icons/unofficial/barista.webp": 53268,
	"./icons/unofficial/baron.webp": 76199,
	"./icons/unofficial/beggar.webp": 55879,
	"./icons/unofficial/bigwig.webp": 19329,
	"./icons/unofficial/bishop.webp": 37074,
	"./icons/unofficial/boffin.webp": 31777,
	"./icons/unofficial/bonecollector.webp": 49147,
	"./icons/unofficial/boomdandy.webp": 78241,
	"./icons/unofficial/bootlegger.webp": 38858,
	"./icons/unofficial/bountyhunter.webp": 9146,
	"./icons/unofficial/buddhist.webp": 35731,
	"./icons/unofficial/bureaucrat.webp": 69225,
	"./icons/unofficial/butcher.webp": 96732,
	"./icons/unofficial/butler.webp": 54303,
	"./icons/unofficial/cacklejack.webp": 79716,
	"./icons/unofficial/cannibal.webp": 42132,
	"./icons/unofficial/cerenovus.webp": 45032,
	"./icons/unofficial/chambermaid.webp": 47445,
	"./icons/unofficial/chef.webp": 83131,
	"./icons/unofficial/choirboy.webp": 66951,
	"./icons/unofficial/clockmaker.webp": 46073,
	"./icons/unofficial/courtier.webp": 30928,
	"./icons/unofficial/cultleader.webp": 51757,
	"./icons/unofficial/custom.webp": 50906,
	"./icons/unofficial/damsel.webp": 69285,
	"./icons/unofficial/demon.webp": 45695,
	"./icons/unofficial/deusexfiasco.webp": 81613,
	"./icons/unofficial/deviant.webp": 49483,
	"./icons/unofficial/devilsadvocate.webp": 58695,
	"./icons/unofficial/djinn.webp": 49518,
	"./icons/unofficial/doomsayer.webp": 20252,
	"./icons/unofficial/dreamer.webp": 24867,
	"./icons/unofficial/drunk.webp": 79378,
	"./icons/unofficial/duchess.webp": 6199,
	"./icons/unofficial/empath.webp": 39484,
	"./icons/unofficial/engineer.webp": 75784,
	"./icons/unofficial/evil.webp": 80267,
	"./icons/unofficial/eviltwin.webp": 71181,
	"./icons/unofficial/exorcist.webp": 77695,
	"./icons/unofficial/fabled.webp": 4564,
	"./icons/unofficial/fanggu.webp": 31436,
	"./icons/unofficial/farmer.webp": 50477,
	"./icons/unofficial/fearmonger.webp": 13364,
	"./icons/unofficial/ferryman.webp": 77547,
	"./icons/unofficial/fibbin.webp": 80588,
	"./icons/unofficial/fiddler.webp": 1927,
	"./icons/unofficial/fisherman.webp": 8901,
	"./icons/unofficial/flowergirl.webp": 67064,
	"./icons/unofficial/fool.webp": 89506,
	"./icons/unofficial/fortuneteller.webp": 5249,
	"./icons/unofficial/gambler.webp": 2526,
	"./icons/unofficial/gangster.webp": 85702,
	"./icons/unofficial/gardener.webp": 85606,
	"./icons/unofficial/general.webp": 7829,
	"./icons/unofficial/gnome.webp": 1804,
	"./icons/unofficial/goblin.webp": 87217,
	"./icons/unofficial/godfather.webp": 36367,
	"./icons/unofficial/godofug.webp": 35515,
	"./icons/unofficial/golem.webp": 89074,
	"./icons/unofficial/good.webp": 31158,
	"./icons/unofficial/goon.webp": 71295,
	"./icons/unofficial/gossip.webp": 16631,
	"./icons/unofficial/grandmother.webp": 42322,
	"./icons/unofficial/gunslinger.webp": 8217,
	"./icons/unofficial/harlot.webp": 87881,
	"./icons/unofficial/harpy.webp": 12463,
	"./icons/unofficial/hatter.webp": 58722,
	"./icons/unofficial/hellslibrarian.webp": 69046,
	"./icons/unofficial/heretic.webp": 68732,
	"./icons/unofficial/hermit.webp": 95587,
	"./icons/unofficial/highpriestess.webp": 88202,
	"./icons/unofficial/hindu.webp": 5949,
	"./icons/unofficial/huntsman.webp": 30037,
	"./icons/unofficial/imp.webp": 46605,
	"./icons/unofficial/innkeeper.webp": 10854,
	"./icons/unofficial/investigator.webp": 13277,
	"./icons/unofficial/judge.webp": 14265,
	"./icons/unofficial/juggler.webp": 63523,
	"./icons/unofficial/kazali.webp": 33929,
	"./icons/unofficial/king.webp": 61697,
	"./icons/unofficial/klutz.webp": 59507,
	"./icons/unofficial/knaves.webp": 54479,
	"./icons/unofficial/knight.webp": 38831,
	"./icons/unofficial/legion.webp": 42070,
	"./icons/unofficial/leviathan.webp": 54050,
	"./icons/unofficial/librarian.webp": 5771,
	"./icons/unofficial/lilmonsta.webp": 70797,
	"./icons/unofficial/lleech.webp": 47526,
	"./icons/unofficial/lordoftyphon.webp": 45347,
	"./icons/unofficial/loric.webp": 83841,
	"./icons/unofficial/lunatic.webp": 82257,
	"./icons/unofficial/lycanthrope.webp": 52403,
	"./icons/unofficial/magician.webp": 7814,
	"./icons/unofficial/marionette.webp": 92331,
	"./icons/unofficial/mastermind.webp": 35162,
	"./icons/unofficial/mathematician.webp": 32205,
	"./icons/unofficial/matron.webp": 71459,
	"./icons/unofficial/mayor.webp": 44268,
	"./icons/unofficial/mezepheles.webp": 87330,
	"./icons/unofficial/minion.webp": 5209,
	"./icons/unofficial/minstrel.webp": 25946,
	"./icons/unofficial/monk.webp": 20499,
	"./icons/unofficial/moonchild.webp": 97237,
	"./icons/unofficial/mutant.webp": 2156,
	"./icons/unofficial/nightwatchman.webp": 71407,
	"./icons/unofficial/noble.webp": 30330,
	"./icons/unofficial/nodashii.webp": 30495,
	"./icons/unofficial/ogre.webp": 71588,
	"./icons/unofficial/ojo.webp": 88986,
	"./icons/unofficial/oracle.webp": 59653,
	"./icons/unofficial/organgrinder.webp": 46208,
	"./icons/unofficial/outsider.webp": 40879,
	"./icons/unofficial/pacifist.webp": 40550,
	"./icons/unofficial/philosopher.webp": 49457,
	"./icons/unofficial/pithag.webp": 33588,
	"./icons/unofficial/pixie.webp": 4558,
	"./icons/unofficial/plaguedoctor.webp": 77191,
	"./icons/unofficial/po.webp": 48256,
	"./icons/unofficial/poisoner.webp": 85096,
	"./icons/unofficial/politician.webp": 91156,
	"./icons/unofficial/pope.webp": 56366,
	"./icons/unofficial/poppygrower.webp": 10420,
	"./icons/unofficial/preacher.webp": 92930,
	"./icons/unofficial/princess.webp": 35699,
	"./icons/unofficial/professor.webp": 12114,
	"./icons/unofficial/psychopath.webp": 60001,
	"./icons/unofficial/pukka.webp": 84679,
	"./icons/unofficial/puzzlemaster.webp": 63216,
	"./icons/unofficial/ravenkeeper.webp": 30671,
	"./icons/unofficial/recluse.webp": 67089,
	"./icons/unofficial/revolutionary.webp": 58757,
	"./icons/unofficial/riot.webp": 68238,
	"./icons/unofficial/sage.webp": 87539,
	"./icons/unofficial/sailor.webp": 86899,
	"./icons/unofficial/saint.webp": 52603,
	"./icons/unofficial/savant.webp": 33725,
	"./icons/unofficial/scapegoat.webp": 21829,
	"./icons/unofficial/scarletwoman.webp": 70800,
	"./icons/unofficial/seamstress.webp": 10435,
	"./icons/unofficial/sentinel.webp": 21401,
	"./icons/unofficial/shabaloth.webp": 19129,
	"./icons/unofficial/shugenja.webp": 5363,
	"./icons/unofficial/slayer.webp": 81142,
	"./icons/unofficial/snakecharmer.webp": 77560,
	"./icons/unofficial/snitch.webp": 7456,
	"./icons/unofficial/soldier.webp": 51790,
	"./icons/unofficial/spiritofivory.webp": 55951,
	"./icons/unofficial/spy.webp": 48602,
	"./icons/unofficial/steward.webp": 76865,
	"./icons/unofficial/stormcatcher.webp": 79367,
	"./icons/unofficial/summoner.webp": 71747,
	"./icons/unofficial/sweetheart.webp": 53821,
	"./icons/unofficial/tealady.webp": 54787,
	"./icons/unofficial/thief.webp": 22332,
	"./icons/unofficial/tinker.webp": 90623,
	"./icons/unofficial/tor.webp": 74771,
	"./icons/unofficial/towncrier.webp": 79709,
	"./icons/unofficial/townsfolk.webp": 66482,
	"./icons/unofficial/toymaker.webp": 57393,
	"./icons/unofficial/traveller.webp": 57578,
	"./icons/unofficial/undertaker.webp": 34633,
	"./icons/unofficial/ventriloquist.webp": 49806,
	"./icons/unofficial/vigormortis.webp": 61297,
	"./icons/unofficial/villageidiot.webp": 66744,
	"./icons/unofficial/virgin.webp": 48317,
	"./icons/unofficial/vizier.webp": 14826,
	"./icons/unofficial/vortox.webp": 21607,
	"./icons/unofficial/voudon.webp": 87711,
	"./icons/unofficial/washerwoman.webp": 11169,
	"./icons/unofficial/widow.webp": 10969,
	"./icons/unofficial/witch.webp": 32912,
	"./icons/unofficial/wizard.webp": 760,
	"./icons/unofficial/wraith.webp": 63079,
	"./icons/unofficial/xaan.webp": 48812,
	"./icons/unofficial/yaggababble.webp": 79947,
	"./icons/unofficial/zealot.webp": 17108,
	"./icons/unofficial/zenomancer.webp": 90339,
	"./icons/unofficial/zombuul.webp": 23516,
	"./icons/ventriloquist.webp": 76824,
	"./icons/vigormortis.webp": 61151,
	"./icons/villageidiot.webp": 53348,
	"./icons/virgin.webp": 34932,
	"./icons/vizier.webp": 35226,
	"./icons/vortox.webp": 63358,
	"./icons/voudon.webp": 68578,
	"./icons/washerwoman.webp": 53338,
	"./icons/widow.webp": 28090,
	"./icons/witch.webp": 24274,
	"./icons/wizard.webp": 20789,
	"./icons/wraith.webp": 39903,
	"./icons/xaan.webp": 117,
	"./icons/yaggababble.webp": 46774,
	"./icons/zealot.webp": 84982,
	"./icons/zenomancer.webp": 88513,
	"./icons/zombuul.webp": 99040,
	"./leaf-left.webp": 62150,
	"./leaf-orange.webp": 7906,
	"./leaf-right.webp": 7883,
	"./leaf-top1.webp": 39898,
	"./leaf-top2.webp": 16247,
	"./leaf-top3.webp": 96184,
	"./leaf-top4.webp": 48207,
	"./leaf-top5.webp": 64224,
	"./leaf-top6.webp": 7031,
	"./leaf-top7.webp": 9792,
	"./life.webp": 24590,
	"./minioninfo.webp": 44288,
	"./plus.webp": 53867,
	"./reminder.webp": 97238,
	"./shroud.webp": 11462,
	"./token.webp": 95021,
	"./vote.webp": 14178,
	"./x.webp": 96455
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97226;